var _a;
import { useState, useEffect } from 'react';
import { getTranslatedErrorMessage } from '../error-translations';
var CHECKOUT_STATICS_VERSION_SERVERLESS_URL = '/_serverless/checkout-statics/checkout-form-statics-version';
var WIX_CHECKOUT_FORM_ACTUAL_MODULE_NAME = 'wixCheckoutForm'; // this is the value in checkout-form's package.json -> yoshi -> exports
export var globalModuleNames = (_a = {},
    _a["checkout" /* BUNDLE_TYPE.CHECKOUT */] = WIX_CHECKOUT_FORM_ACTUAL_MODULE_NAME,
    _a["updatePaymentMethod" /* BUNDLE_TYPE.UPM */] = '__WIX-CHECKOUT-FORM_BUNDLE_UPM__',
    _a["payNow" /* BUNDLE_TYPE.PayNow */] = '__WIX-CHECKOUT-FORM_BUNDLE_PAY_NOW__',
    _a["editInvoiceDetails" /* BUNDLE_TYPE.EditInvoiceDetails */] = '__WIX-CHECKOUT-FORM_BUNDLE_EDIT_INVOICE_DETAILS__',
    _a["createPaymentMehtod" /* BUNDLE_TYPE.CPM */] = '__WIX-CHECKOUT-FORM_BUNDLE_CPM__',
    _a["orderSummary" /* BUNDLE_TYPE.ORDER_SUMMARY */] = '__WIX-CHECKOUT-FORM_BUNDLE_ORDER_SUMMARY__',
    _a);
export var useStaticsFromCdn = function (_a) {
    var httpClient = _a.httpClient, _b = _a.bundleType, bundleType = _b === void 0 ? "checkout" /* BUNDLE_TYPE.CHECKOUT */ : _b, _c = _a.onError, onError = _c === void 0 ? function () { } : _c, _d = _a.flowType, flowType = _d === void 0 ? 'checkout' : _d, _e = _a.locale, locale = _e === void 0 ? 'en' : _e;
    var globalModuleName = globalModuleNames[bundleType];
    var _f = useState(false), scriptLoaded = _f[0], setScriptLoaded = _f[1];
    var _g = useState(false), styleLoaded = _g[0], setStyleLoaded = _g[1];
    var isLoaded = scriptLoaded && styleLoaded;
    useEffect(function () {
        if (window[globalModuleName]) {
            setStyleLoaded(true);
            setScriptLoaded(true);
            return;
        }
        void fetchCheckoutStatics(httpClient, bundleType, function () {
            setStyleLoaded(true);
        }, function () {
            setScriptLoaded(true);
        }, onError, flowType, locale);
    });
    if (isLoaded || process.env.NODE_ENV === 'test') {
        return window[globalModuleName];
    }
    return null;
};
export var fetchCheckoutStatics = function (httpClient, bundleType, onLoadStyles, onLoadScripts, onError, flowType, locale) {
    if (bundleType === void 0) { bundleType = "checkout" /* BUNDLE_TYPE.CHECKOUT */; }
    if (onLoadStyles === void 0) { onLoadStyles = function () { }; }
    if (onLoadScripts === void 0) { onLoadScripts = function () { }; }
    if (onError === void 0) { onError = function () { }; }
    if (flowType === void 0) { flowType = 'checkout'; }
    if (locale === void 0) { locale = 'en'; }
    var globalModuleName = globalModuleNames[bundleType];
    // don't load if it's already loaded (fetchCheckoutStatics may be called from consumer multiple times)
    if (window[globalModuleName]) {
        return;
    }
    var script = document.createElement('script');
    script.crossOrigin = 'anonymous';
    var style = document.createElement('link');
    return httpClient
        .get(CHECKOUT_STATICS_VERSION_SERVERLESS_URL)
        .then(function (_a) {
        var data = _a.data;
        var baseUrl = "".concat(data, "/").concat(bundleType);
        // stylesheet
        style.href = "".concat(baseUrl, ".min.css");
        style.rel = 'stylesheet';
        style.onload = onLoadStyles;
        style.onerror = function () {
            onError(new Error("checkout-components: Unable to load ".concat(bundleType, " styles.")), undefined, {
                failureReason: 'NETWORK_ERROR',
                translatedErrorMessage: getTranslatedErrorMessage(locale, flowType),
            });
        };
        document.head.appendChild(style);
        // script
        script.src = bundleType === "orderSummary" /* BUNDLE_TYPE.ORDER_SUMMARY */ ? "".concat(baseUrl, ".umd.min.js") : "".concat(baseUrl, ".bundle.min.js");
        script.onload = function () {
            if (bundleType !== "checkout" /* BUNDLE_TYPE.CHECKOUT */) {
                // the module was temporarily loaded to window.wixCheckoutForm, which is the same variable for all bundle-types and can be overridden if another bundle is loaded.
                // so for all flows other than checkout, move it to the permanent window[globalModuleName] which is specific to the bundle-type
                window[globalModuleName] =
                    window[WIX_CHECKOUT_FORM_ACTUAL_MODULE_NAME];
                window[WIX_CHECKOUT_FORM_ACTUAL_MODULE_NAME] = undefined;
            }
            onLoadScripts();
        };
        script.onerror = function () {
            onError(new Error("checkout-components: Unable to load ".concat(bundleType, " bundle.")), undefined, {
                failureReason: 'NETWORK_ERROR',
                translatedErrorMessage: getTranslatedErrorMessage(locale, flowType),
            });
        };
        document.body.appendChild(script);
    })
        .catch(function (error) {
        onError(error, undefined, {
            failureReason: 'NETWORK_ERROR',
            translatedErrorMessage: getTranslatedErrorMessage(locale, flowType),
        });
        // For backward compatibility.
        // Some consumers expect errors to be thrown from this function
        // in the prefetch flows.
        throw error;
    });
};
//# sourceMappingURL=useStaticsFromCdn.js.map